module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_08.e790dd43.jpg";